"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hygiene_1 = require("@stopify/hygiene");
const visitor = {
    MemberExpression(path) {
        const object = path.node.object;
        const property = path.node.property;
        // Look for arguments['callee'] or arguments.callee
        if (object.type === 'Identifier' && object.name === 'arguments' &&
            ((path.node.computed &&
                property.type === 'StringLiteral' &&
                property.value === 'callee') ||
                (!path.node.computed &&
                    property.type === 'Identifier' &&
                    property.name === 'callee'))) {
            const functionParent = path.getFunctionParent();
            let id;
            if (!functionParent.node.id) {
                id = hygiene_1.fresh('funExpr');
                functionParent.node.id = id;
            }
            else {
                id = functionParent.node.id;
            }
            path.replaceWith(id);
        }
    }
};
function default_1() {
    return { visitor: visitor };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xlYW51cC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RzL2NsZWFudXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFTQSw4Q0FBeUM7QUFFekMsTUFBTSxPQUFPLEdBQUc7SUFFZCxnQkFBZ0IsQ0FBQyxJQUFrQztRQUNqRCxNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUNoQyxNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQztRQUNwQyxtREFBbUQ7UUFDbkQsSUFBSSxNQUFNLENBQUMsSUFBSSxLQUFLLFlBQVksSUFBSSxNQUFNLENBQUMsSUFBSSxLQUFLLFdBQVc7WUFDM0QsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTtnQkFDbEIsUUFBUSxDQUFDLElBQUksS0FBSyxlQUFlO2dCQUNqQyxRQUFRLENBQUMsS0FBSyxLQUFLLFFBQVEsQ0FBQztnQkFDN0IsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTtvQkFDbkIsUUFBUSxDQUFDLElBQUksS0FBSyxZQUFZO29CQUM5QixRQUFRLENBQUMsSUFBSSxLQUFLLFFBQVEsQ0FBQyxDQUFDLEVBQUU7WUFDbEMsTUFBTSxjQUFjLEdBQUcsSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBQUM7WUFDaEQsSUFBSSxFQUFFLENBQUM7WUFDUCxJQUFJLENBQWMsY0FBYyxDQUFDLElBQUssQ0FBQyxFQUFFLEVBQUU7Z0JBQ3pDLEVBQUUsR0FBRyxlQUFLLENBQUMsU0FBUyxDQUFDLENBQUM7Z0JBQ1QsY0FBYyxDQUFDLElBQUssQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO2FBQzNDO2lCQUFNO2dCQUNMLEVBQUUsR0FBZ0IsY0FBYyxDQUFDLElBQUssQ0FBQyxFQUFFLENBQUM7YUFDM0M7WUFDRCxJQUFJLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxDQUFDO1NBQ3RCO0lBQ0gsQ0FBQztDQUNGLENBQUM7QUFFRjtJQUNFLE9BQU8sRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDOUIsQ0FBQztBQUZELDRCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ../normalize-js/dist/ts/cleanup.js
// module id = 798
// module chunks = 0